export const log = () => {};

export const error = (message, ...optionalParams) => {
  console.error(message, ...optionalParams);
};
